// import { getListClass, getListSubjectInWeek, getListMember, getListDocument} from '../_api'
import * as types from './constants';
import * as api from '../_api'
// const actionGetListClass = (context) => {
//     console.log("action ok")
//     return context.commit('SET_LIST_CLASS', getListClass());
// };
const actionGetListClass = ({ commit }, params = { data }) => {
    api.getListClass(params)
        .then((response) => {
            commit(types.SET_LIST_CLASS, response.data);
        })
        .catch((error) => {
            // eslint-disable-next-line
            console.error(error);
        });
};
const actionClassListDocument = ({ commit }, params = { data }) => {
    api.getClassListDoccument(params)
        .then((response) => {
            commit(types.GET_LIST_CLASS_DOCCUMENT, response.data);
        })
        .catch((error) => {
            // eslint-disable-next-line
            console.error(error);
        });
};
const actionListEvent = ({ commit }, params = { data }) => {
    api.getListEvent(params)
        .then((response) => {
            commit(types.GET_LIST_CLASS_EVENT, response.data);
        })
        .catch((error) => {
            // eslint-disable-next-line
            console.error(error);
        });
};

const actionListEventByUser = ({ commit }, params = {}) => {
    api.getListEventByUser(params)
        .then((response) => {
            commit(types.GET_LIST_CLASS_EVENT, response.data);
        })
        .catch((error) => {
            // eslint-disable-next-line
            console.error(error);
        });
};

const actionGetListLessonPlan = ({ commit }, id) => {
    api.getListLessonPlan(id)
        .then((response) => {
            commit(types.GET_LIST_LESSON_PLAN, response.data);
        })
        .catch((error) => {
            // eslint-disable-next-line
            console.error(error);
        });
};
const actionGetListClassPosition = ({ commit }, params = {}) => {
    api.getListClassPosition(params)
        .then((response) => {
            commit(types.GET_LIST_CLASS_POSITION, response.data);
        })
        .catch((error) => {
            // eslint-disable-next-line
            console.error(error);
        });
};

const actionClassSchoolListMember = ({ commit }, params = { data }) => {
    api.ClassSchoolListMember(params)
        .then((response) => {
            commit(types.CLASS_SCHOOL_LIST_MEMBER, response.data);
        })
        .catch((error) => {
            // eslint-disable-next-line
            console.error(error);
        });
};

const actionGetCourseDetail = ({ commit }, id) => {
    api.getCourseDetail(id)
        .then((response) => {
            commit(types.GET_COURSE_DETAIL, response.data);
        })
        .catch((error) => {
            // eslint-disable-next-line
            console.error(error);
        });
};
const actionEventDetail = ({ commit }, id) => {
    api.getEventDetail(id)
        .then((response) => {
            commit(types.GET_DETAIL_EVENT, response.data);
        })
        .catch((error) => {
            // eslint-disable-next-line
            console.error(error);
        });
};
const actionGetListSubjectInWeek = ({ commit }, id) => {
    api.getListLessonPlanChildren(id)
        .then((response) => {
            commit(types.SET_LIST_SUBJECT, response.data);
        })
        .catch((error) => {
            // eslint-disable-next-line
            console.error(error);
        });
};
// const actionGetListSubjectInWeek = (context) => {
//     console.log("action ok")
//     return context.commit('SET_LIST_SUBJECT', getListSubjectInWeek());
// };

const actionGetListMember = (context) => {
    return context.commit('GET_LIST_MEMBER', getListMember());
};

// const actionGetListDocument = (context) => {
//     console.log("action ok")
//     return context.commit('GET_LIST_DOCUMENT', getListDocument());
// };

const SetEventCalendar = ({ commit }, data) => {
    commit(types.SET_EVENT_CALENDAR, data)
};
const actionSetParamListSchool = ({ commit }, data) => {
    return commit(types.SET_PARAM_LIST_SCHOOL, data);
}
const actionSetpramsDoccument = ({ commit }, data) => {
    return commit(types.SET_PARAM_DOCCUMENT, data);
}



export default {
    actionGetListClass,
    actionGetListSubjectInWeek,
    actionGetListMember,
    // actionGetListDocument,
    SetEventCalendar,
    actionSetParamListSchool,
    actionGetCourseDetail,
    actionClassSchoolListMember,
    actionGetListLessonPlan,
    actionSetpramsDoccument,
    actionClassListDocument,
    actionListEvent,
    actionEventDetail,
    actionGetListClassPosition,
    actionListEventByUser
};